export enum ChatSettingAction {
  INIT_CHATBOT_SETTING = 'chatsetting/INIT_CHATBOT_SETTING'
}
export enum ChatIconSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small'
}

export enum ChatLauncherStyleType {
  StyleA = 'A',
  StyleB = 'B',
  StyleC = 'C'
}

interface InitChatbot {
  type: ChatSettingAction.INIT_CHATBOT_SETTING;
  payload: {
    chatSettingData: IChatSettingState;
  };
}

export interface IChatSettingState {
  mainColor: string;
  subColor: string;
  title: string;
  titleImage: string;
  iconImage: string;
  launcherImage: string;
  mainTitle: string;
  iconSize: ChatIconSize;
  launcherStyleType: ChatLauncherStyleType;
}

export type ChatSettingActionTypes = InitChatbot;
